import { getDataflowSinkIndex } from 'ts/perspectives/findings/details/TaintAnalysisFindingUtils';
import type { ExtendedStatementPathElement } from 'ts/perspectives/metrics/code/ExtendedStatementPathElement';

/** Infos regarding the dataflow visualization for individual lines. */
export type DataflowInfos = {
	isSink: boolean;
	isSource: boolean;
	traces?: ExtendedStatementPathElement[];
};

/** Builds the DataflowInfos by code line from the given statement paths. */
export function buildDataflowInfos(statementPathsOfFile: ExtendedStatementPathElement[]): Map<number, DataflowInfos> {
	const sinkIndex = getDataflowSinkIndex(statementPathsOfFile);
	const dataflowInfosByLine = new Map<number, DataflowInfos>();

	statementPathsOfFile.forEach(statementPath => {
		for (
			let lineNumber = statementPath.location.rawStartLine;
			lineNumber <= statementPath.location.rawEndLine;
			lineNumber++
		) {
			const dataflowInfo: Partial<DataflowInfos> = dataflowInfosByLine.get(lineNumber) ?? {};
			dataflowInfo.isSource ||= statementPath.index === 0;
			dataflowInfo.isSink ||= statementPath.index === sinkIndex;
			dataflowInfosByLine.set(lineNumber, dataflowInfo as DataflowInfos);
		}
		const endLine = statementPath.location.rawEndLine;
		const traces = dataflowInfosByLine.get(endLine)!.traces ?? [];
		traces.push(statementPath);
		dataflowInfosByLine.get(endLine)!.traces = traces;
	});
	return dataflowInfosByLine;
}
